import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_deleteLandingPage, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_deleteLandingPage';

export type LandingPageModelType = Response200Type;

const decode = (status: number, data: ResponseType): LandingPageModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface LandingPageTypeSubmitType {
    id: number
}

export const deleteLandingPage = {
    browser: {
        params: (params: LandingPageTypeSubmitType): ParamsFetchType<LandingPageTypeSubmitType> => {
            return {
                type: MethodType.DELETE,
                url: '/api-web/delete_landing_page',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.DELETE,
        urlBrowser: '/api-web/delete_landing_page',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<LandingPageTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_website_cms_deleteLandingPage(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            id: params.req.body.id,
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
